//NOTE: 対応する特殊文字
type SpecialCharacters = ReadonlyArray<'"' | "'">;
const specialCharacters: SpecialCharacters = ['"', "'"];

export function searchSuggestion(keyphrase: string, suggestions: string[]): string[] {
  const searchSuggestions = suggestions.filter((suggestion) => {
    // NOTE: 英語の場合は大・小文字の区別はしない。
    const lowerCaseSuggestion = suggestion.toLocaleLowerCase("en-US");
    const lowerCasekeyphrase = keyphrase.toLocaleLowerCase("en-US");
    // NOTE: CommandItem コンポーネントに入力値と同じものがある場合、
    // ↓キーでのアイテム選択時の挙動がおかしくなるため、あらかじめ、除外する。
    return lowerCaseSuggestion !== lowerCasekeyphrase && lowerCaseSuggestion.startsWith(lowerCasekeyphrase);
  });
  return searchSuggestions;
}

export function removeStartSpecialCharacter(keyword: string): string {
  if (hasStartWithSpecialCharacter(keyword)) return keyword.slice(1);
  return keyword;
}

export function removeStartAndEndSpecialCharacter(keyword: string): string {
  if (hasStartWithSpecialCharacter(keyword) && hasEndWithSpecialCharacter(keyword)) return keyword.slice(1, -1);
  return keyword;
}

export function getStartSpecialCharacter(keyword: string): string {
  if (hasStartWithSpecialCharacter(keyword)) return keyword.charAt(0);
  return "";
}

function hasStartWithSpecialCharacter(keyword: string, chars: SpecialCharacters = specialCharacters): boolean {
  return (chars as string[]).includes(keyword.charAt(0));
}

function hasEndWithSpecialCharacter(keyword: string, chars: SpecialCharacters = specialCharacters): boolean {
  return (chars as string[]).includes(keyword.charAt(keyword.length - 1));
}
